<template>

  <head>

    <meta charset="utf-8" />
    <title>Revenue Team Lineup | County Management System</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Revenue management system" name="description" />
    <meta content="County Revenue System" name="author" />
    <!-- App favicon -->
    <link rel="shortcut icon" href="assets/images/favicon.svg">
    <!-- droping file -->
    <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css" />

    <!-- DataTables -->
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css" />

    <!-- Bootstrap Css -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <!-- Bootstrap select styling -->
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <!-- App Css-->
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <!-- custom Css-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />

  </head>

  <body @contextmenu.prevent data-sidebar="dark">

  <!-- Begin page -->
  <div id="layout-wrapper">

    <NavigationBar/>

    <!-- ============================================================== -->
    <!-- Start right Content here -->
    <!-- ============================================================== -->
    <div id="content" class="content-minimize">

      <div class="page-content">
        <div class="container-fluid">

          <!-- start page title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <div>
                  <h4 class="mb-sm-0 font-size-18">Revenue Team Lineup for {{formatSubCountyName(subCountyName)}}</h4>
                  <p class="text-muted mb-0">Period: {{formatDate(dateFrom)}} to {{formatDate(dateTo)}}</p>
                </div>

                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="javascript:void(0)">Dashboard</a></li>
                    <li class="breadcrumb-item"><a href="javascript:void(0)">Reports</a></li>
                    <li class="breadcrumb-item"><a href="javascript:void(0)">Revenue by Sub County</a></li>
                    <li class="breadcrumb-item">{{formatSubCountyName(subCountyName)}}</li>
                    <li class="breadcrumb-item active">Team Lineup</li>
                  </ol>
                </div>

              </div>
            </div>
          </div>
          <!-- end page title -->

          <!-- Summary Cards -->
          <div class="row mb-4">
            <div class="col-xl-3 col-md-6">
              <div class="card card-h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <span class="text-muted mb-3 lh-1 d-block text-truncate">Total Collection</span>
                      <h4 class="mb-3">
                        <span class="counter-value text-success">KES {{numberFormat(totalAmountCollected)}}</span>
                      </h4>
                    </div>
                    <div class="flex-shrink-0">
                      <div class="avatar-sm rounded-circle bg-success">
                                                <span class="avatar-title rounded-circle bg-success">
                                                    <i class="bx bx-money font-size-24"></i>
                                                </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card card-h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <span class="text-muted mb-3 lh-1 d-block text-truncate">Total Staff</span>
                      <h4 class="mb-3">
                        <span class="counter-value">{{numberFormat(totalNumber)}}</span>
                      </h4>
                    </div>
                    <div class="flex-shrink-0">
                      <div class="avatar-sm rounded-circle bg-primary">
                                                <span class="avatar-title rounded-circle bg-primary">
                                                    <i class="bx bx-group font-size-24"></i>
                                                </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card card-h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <span class="text-muted mb-3 lh-1 d-block text-truncate">Total Inspections</span>
                      <h4 class="mb-3">
                        <span class="counter-value">{{numberFormat(totalInspections)}}</span>
                      </h4>
                    </div>
                    <div class="flex-shrink-0">
                      <div class="avatar-sm rounded-circle bg-info">
                                                <span class="avatar-title rounded-circle bg-info">
                                                    <i class="bx bx-search-alt font-size-24"></i>
                                                </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card card-h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <span class="text-muted mb-3 lh-1 d-block text-truncate">Inspection Value</span>
                      <h4 class="mb-3">
                        <span class="counter-value text-warning">KES {{numberFormat(totalInspectionsValue)}}</span>
                      </h4>
                    </div>
                    <div class="flex-shrink-0">
                      <div class="avatar-sm rounded-circle bg-warning">
                                                <span class="avatar-title rounded-circle bg-warning">
                                                    <i class="bx bx-chart-line font-size-24"></i>
                                                </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- toolbar start -->
          <SubCountyReportsToolBar/>
          <!-- toobar end -->

          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-white border-bottom">
                  <div class="row align-items-center">
                    <div class="col-md-6">
                      <h5 class="card-title mb-0">Team Role Performance</h5>
                      <small class="text-muted">Showing {{revenueTeamLine.length}} role categories</small>
                    </div>
                    <div class="col-md-6">
                      <div class="d-flex justify-content-end gap-2">
                        <button @click="refreshData()" type="button" class="btn btn-outline-primary btn-sm" :disabled="loading">
                          <i class="bx bx-refresh" :class="{'bx-spin': loading}"></i>
                          {{ loading ? 'Refreshing...' : 'Refresh' }}
                        </button>
                        <button v-if="getRight('DOWNLOAD REPORTS')" @click="downloadRevenueTeamLineUp()"
                                type="button" class="btn btn-success btn-sm" :disabled="downloading">
                          <i class="bx bx-download"></i> {{download}}
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="row mt-3">
                    <div class="col-md-4">
                      <div class="search-box">
                        <div class="position-relative">
                          <input v-model="search" type="text" class="form-control" placeholder="Search roles..." />
                          <i class="bx bx-search-alt search-icon"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-8">
                      <div class="d-flex justify-content-end gap-2">
                        <div class="d-flex align-items-center">
                          <label class="form-label mb-0 me-2">From:</label>
                          <input v-model="dateFrom" class="form-control form-control-sm" type="date" style="width: auto;">
                        </div>
                        <div class="d-flex align-items-center">
                          <label class="form-label mb-0 me-2">To:</label>
                          <input v-model="dateTo" class="form-control form-control-sm" type="date" style="width: auto;">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card-body p-0">
                  <div v-if="loading" class="text-center py-5">
                    <div class="spinner-border text-primary mb-3" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                    <h5>Loading Team Data...</h5>
                    <p class="text-muted">Please wait while we fetch the latest team performance data.</p>
                  </div>

                  <div v-else-if="revenueTeamLine.length === 0" class="text-center py-5">
                    <div class="py-4">
                      <i class="bx bx-group font-size-96 text-muted"></i>
                      <h4 class="mt-3">No Team Data Found</h4>
                      <p class="text-muted">No team lineup data found for the selected criteria.</p>
                      <button @click="clearFilters()" class="btn btn-outline-primary">Clear Filters</button>
                    </div>
                  </div>

                  <div v-else class="table-responsive">
                    <table class="table table-hover align-middle mb-0">
                      <thead class="table-dark">
                      <tr>
                        <th style="width: 60px;">#</th>
                        <th>System Role</th>
                        <th class="text-center" style="width: 100px;">Staff Count</th>
                        <th class="text-center" style="width: 120px;">Collections</th>
                        <th class="text-center" style="width: 120px;">Inspections</th>
                        <th class="text-center" style="width: 120px;">Communication</th>
                        <th class="text-end" style="width: 150px;">Collection Value</th>
                        <th class="text-end" style="width: 150px;">Inspection Value</th>
                        <th class="text-center" style="width: 120px;">Actions</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr :key="index" :value="item" v-for="(item, index) in sortedTeamLine">
                        <td class="text-center">
                          <span class="badge bg-light text-dark rounded-pill">{{index+1}}</span>
                        </td>
                        <td>
                          <div class="d-flex align-items-center">
                            <div class="me-3">
                              <div class="avatar-xs">
                                                                    <span class="avatar-title rounded" :class="getRoleColor(item.category)">
                                                                        {{getRoleInitials(item.category)}}
                                                                    </span>
                              </div>
                            </div>
                            <div>
                              <h6 class="mb-0">
                                <a @click="gotTo(item.category,'reports-sub-county-team-details')"
                                   href="javascript: void(0);" class="text-decoration-none">{{formatRoleName(item.category)}}</a>
                              </h6>
                              <small class="text-muted">{{getRoleDescription(item.category)}}</small>
                            </div>
                          </div>
                        </td>
                        <td class="text-center">
                          <span class="badge bg-primary">{{numberFormat(item.totalNumber)}}</span>
                        </td>
                        <td class="text-center">
                          <div class="d-flex flex-column align-items-center">
                            <span class="fw-bold">{{numberFormat(item.collections)}}</span>
                            <small class="text-muted">transactions</small>
                          </div>
                        </td>
                        <td class="text-center">
                          <div class="d-flex flex-column align-items-center">
                            <span class="fw-bold">{{numberFormat(item.inspection)}}</span>
                            <small class="text-muted">inspections</small>
                          </div>
                        </td>
                        <td class="text-center">
                          <div class="d-flex flex-column align-items-center">
                            <small class="text-success">In: {{numberFormat(item.incoming)}}</small>
                            <small class="text-warning">Out: {{numberFormat(item.outgoing)}}</small>
                          </div>
                        </td>
                        <td class="text-end">
                          <div class="d-flex flex-column align-items-end">
                            <strong class="text-success mb-1">KES {{numberFormat(item.amountCollected)}}</strong>
                            <div class="d-flex align-items-center" style="width: 100px;">
                              <div class="progress flex-grow-1 me-2" style="height: 8px;">
                                <div class="progress-bar bg-success"
                                     :style="`width: ${getCollectionPercentage(item.amountCollected)}%`">
                                </div>
                              </div>
                              <small class="text-muted" style="min-width: 30px;">{{getCollectionPercentage(item.amountCollected)}}%</small>
                            </div>
                          </div>
                        </td>
                        <td class="text-end">
                          <div class="d-flex flex-column align-items-end">
                            <strong class="text-primary mb-1">KES {{numberFormat(item.inspectionValue)}}</strong>
                            <div class="d-flex align-items-center" style="width: 100px;">
                              <div class="progress flex-grow-1 me-2" style="height: 8px;">
                                <div class="progress-bar bg-primary"
                                     :style="`width: ${getInspectionPercentage(item.inspectionValue)}%`">
                                </div>
                              </div>
                              <small class="text-muted" style="min-width: 30px;">{{getInspectionPercentage(item.inspectionValue)}}%</small>
                            </div>
                          </div>
                        </td>
                        <td class="text-center">
                          <button @click="gotTo(item.category,'reports-sub-county-team-details')"
                                  type="button" class="btn btn-primary btn-sm">
                            <i class="bx bx-show me-1"></i> View
                          </button>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="card-footer bg-light" v-if="revenueTeamLine.length > 0">
                  <!-- Summary Row -->
                  <div class="row">
                    <div class="col-12">
                      <div class="d-flex justify-content-between align-items-center">
                        <div>
                          <strong>{{numberFormat(revenueTeamLine.length)}} Role Categories</strong>
                        </div>
                        <div class="text-end">
                          <div><strong>{{numberFormat(totalNumber)}} Total Staff</strong></div>
                          <div><strong>{{numberFormat(totalCollection)}} Collections</strong></div>
                          <div class="text-success"><strong>KES {{numberFormat(totalAmountCollected)}}</strong></div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Team Analysis -->
                  <div v-if="revenueTeamLine.length > 0" class="mt-4 pt-3 border-top bg-light">
                    <div class="row">
                      <div class="col-md-6">
                        <h6 class="mb-3 text-primary">
                          <i class="bx bx-trophy me-2"></i>
                          Top Performing Roles
                        </h6>
                        <div v-for="(item, index) in getTopRoles()" :key="index" class="mb-3">
                          <div class="d-flex justify-content-between align-items-center mb-1">
                                                        <span class="fw-medium">
                                                            <span class="badge bg-primary me-2">{{ index + 1 }}</span>
                                                            {{ formatRoleName(item.category) }}
                                                        </span>
                            <strong class="text-success">KES {{ numberFormat(item.amountCollected) }}</strong>
                          </div>
                          <div class="progress" style="height: 12px;">
                            <div class="progress-bar bg-success"
                                 :style="`width: ${getCollectionPercentage(item.amountCollected)}%`">
                              {{ getCollectionPercentage(item.amountCollected) }}%
                            </div>
                          </div>
                          <small class="text-muted">
                            {{ numberFormat(item.totalNumber) }} staff • {{ numberFormat(item.collections) }} collections
                          </small>
                        </div>
                      </div>

                      <div class="col-md-6">
                        <h6 class="mb-3 text-info">
                          <i class="bx bx-chart-bar me-2"></i>
                          Team Insights
                        </h6>
                        <ul class="list-unstyled">
                          <li class="mb-2">
                            <i class="bx bx-crown text-warning me-2"></i>
                            <strong>{{ getTopRole()?.category ? formatRoleName(getTopRole().category) : 'N/A' }}</strong> leads in collections
                          </li>
                          <li class="mb-2">
                            <i class="bx bx-search-alt text-info me-2"></i>
                            Total inspections performed:
                            <span class="fw-bold">{{ numberFormat(totalInspections) }}</span>
                          </li>
                          <li class="mb-2">
                            <i class="bx bx-phone text-success me-2"></i>
                            Communication activity:
                            <span class="fw-bold">{{ numberFormat(totalIncoming + totalOutgoing) }} calls</span>
                          </li>
                          <li class="mb-2">
                            <i class="bx bx-calculator text-primary me-2"></i>
                            Average per staff member:
                            <span class="fw-bold">KES {{ getAveragePerStaff() }}</span>
                          </li>
                          <li class="mb-2">
                            <i class="bx bx-trending-up text-success me-2"></i>
                            Collection efficiency:
                            <span class="fw-bold">{{ getCollectionEfficiency() }}%</span>
                          </li>
                        </ul>
                      </div>
                    </div>

                    <!-- Role Distribution -->
                    <div class="row mt-4">
                      <div class="col-12">
                        <h6 class="mb-3">Role Distribution & Performance</h6>
                        <div class="row">
                          <div class="col-md-4">
                            <div class="card text-center border-success">
                              <div class="card-body py-3">
                                <h4 class="text-success mb-1">{{ getHighValueRoles().length }}</h4>
                                <p class="mb-0 text-muted">High Value Roles</p>
                                <small class="text-success">>30% of total collection</small>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="card text-center border-warning">
                              <div class="card-body py-3">
                                <h4 class="text-warning mb-1">{{ getMediumValueRoles().length }}</h4>
                                <p class="mb-0 text-muted">Medium Value Roles</p>
                                <small class="text-warning">10-30% of total</small>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="card text-center border-info">
                              <div class="card-body py-3">
                                <h4 class="text-info mb-1">{{ getSupportRoles().length }}</h4>
                                <p class="mb-0 text-muted">Support Roles</p>
                                <small class="text-info">{{'<10% of total'}}</small>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Management Recommendations -->
                    <div class="row mt-4">
                      <div class="col-12">
                        <div class="alert alert-info">
                          <h6 class="alert-heading">
                            <i class="bx bx-lightbulb me-2"></i>
                            Team Management Insights
                          </h6>
                          <div class="row">
                            <div class="col-md-6">
                              <ul class="mb-0">
                                <li>{{ getTopRole()?.category ? formatRoleName(getTopRole().category) : 'Top role' }} generates highest revenue - consider expansion</li>
                                <li>Average efficiency is {{ getCollectionEfficiency() }}% - target improvements</li>
                                <li>{{ numberFormat(totalInspections) }} inspections completed - monitor quality</li>
                              </ul>
                            </div>
                            <div class="col-md-6">
                              <ul class="mb-0">
                                <li>Communication activity: {{ numberFormat(totalIncoming + totalOutgoing) }} total calls</li>
                                <li>Consider cross-training between high and low performing roles</li>
                                <li>Review resource allocation based on collection performance</li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <!-- end col -->
          </div>

          <!-- end row -->
        </div>
        <!-- container-fluid -->
      </div>
      <!-- End Page-content -->

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6">©County Revenue System</div>
            <div class="col-sm-6">
              <div class="text-sm-end d-sm-block">
                Developed by County IT Department
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
    <!-- end main content-->

  </div>
  <!-- END layout-wrapper -->

  <!-- Right bar overlay-->
  <div class="rightbar-overlay"></div>

  </body>

</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation";
import SubCountyReportsToolBar from "@/components/reports/collectionbysubcounties/SubCountyReportsToolBar";
import {authUrl, biller, execute, executeDownload, getRight} from "@/api";
import moment from 'moment';

export default {
  name: "ReportsSubCountyTeam",
  components: {SubCountyReportsToolBar, NavigationBar},
  data() {
    return {
      download:'Download Report',
      downloading: false,
      loading: false,
      currentPage: 1,
      totalPages: 0,
      pageSize: 10,
      totalItems:0,
      subCountyName:'',
      subCountyID:'',
      dateRange:'',
      dateTo:'',
      dateFrom:'',
      search:'',
      totalAmount:null,
      totalInspections: 0,
      totalIncoming: 0,
      totalOutgoing: 0,
      totalNumber: 0,
      totalInspectionsValue: 0,
      totalAmountCollected: 0,
      totalCollection: 0,

      revenueTeamLine: [],
    };
  },
  watch: {
    search(){
      this.revenueTeamLineUp()
    }
  },
  computed:{
    startIndex() {
      return (this.currentPage - 1) * this.pageSize;
    },
    endIndex() {
      return this.currentPage * this.pageSize;
    },

    sortedTeamLine() {
      return [...this.revenueTeamLine].sort((a, b) => Number(b.amountCollected) - Number(a.amountCollected));
    }
  },
  mounted() {
    this.subCountyID = sessionStorage.getItem("subCountyID")
    this.subCountyName = sessionStorage.getItem("subCountyName")
    this.dateTo = sessionStorage.getItem("dateTo")
    this.dateFrom = sessionStorage.getItem("dateFrom")
    this.search = this.subCountyName

    this.$watch('dateFrom', function (newValue) {
      if (this.dateFrom === '' || this.dateTo === '') {
        return;
      } else {
        this.revenueTeamLineUp()
      }
    })

    this.$watch('dateTo', function (newValue) {
      if (this.dateFrom === '' || this.dateTo === '') {
        return;
      } else {
        this.revenueTeamLineUp()
      }
    })

    this.revenueTeamLineUp()
    this.menuAccess()
  },
  methods: {

    // Helper methods for better UX
    formatSubCountyName(name) {
      if (!name || name === 'undefined') return 'Unknown';
      return name.toLowerCase().split(' ').map(word =>
          word.charAt(0).toUpperCase() + word.slice(1)
      ).join(' ');
    },

    formatRoleName(role) {
      if (!role) return 'Unknown Role';
      return role.toLowerCase().split(' ').map(word =>
          word.charAt(0).toUpperCase() + word.slice(1)
      ).join(' ');
    },

    getRoleInitials(role) {
      if (!role) return '?';
      return role.split(' ').map(word => word.charAt(0)).join('').substring(0, 2).toUpperCase();
    },

    getRoleColor(role) {
      const colors = {
        'COLLECTOR': 'bg-success text-white',
        'INSPECTOR': 'bg-warning text-dark',
        'ENFORCER': 'bg-danger text-white',
        'SUPERVISOR': 'bg-info text-white'
      };
      return colors[role?.toUpperCase()] || 'bg-primary text-white';
    },

    getRoleDescription(role) {
      const descriptions = {
        'COLLECTOR': 'Revenue Collection',
        'INSPECTOR': 'Compliance Inspection',
        'ENFORCER': 'Enforcement Activities',
        'SUPERVISOR': 'Team Supervision'
      };
      return descriptions[role?.toUpperCase()] || 'Team Member';
    },

    getCollectionPercentage(amount) {
      if (this.totalAmountCollected === 0) return 0;
      return ((Number(amount) / this.totalAmountCollected) * 100).toFixed(1);
    },

    getInspectionPercentage(amount) {
      if (this.totalInspectionsValue === 0) return 0;
      return ((Number(amount) / this.totalInspectionsValue) * 100).toFixed(1);
    },

    getAveragePerStaff() {
      if (this.totalNumber === 0) return '0';
      return this.numberFormat(Math.round(this.totalAmountCollected / this.totalNumber));
    },

    getCollectionEfficiency() {
      if (this.totalInspectionsValue === 0) return '0';
      return ((this.totalAmountCollected / this.totalInspectionsValue) * 100).toFixed(1);
    },

    getTopRoles() {
      return this.sortedTeamLine.slice(0, 3);
    },

    getTopRole() {
      if (this.revenueTeamLine.length === 0) return null;
      return this.revenueTeamLine.reduce((max, current) =>
          Number(current.amountCollected) > Number(max.amountCollected) ? current : max
      );
    },

    getHighValueRoles() {
      return this.revenueTeamLine.filter(role =>
          this.getCollectionPercentage(role.amountCollected) > 30
      );
    },

    getMediumValueRoles() {
      return this.revenueTeamLine.filter(role => {
        const percentage = this.getCollectionPercentage(role.amountCollected);
        return percentage >= 10 && percentage <= 30;
      });
    },

    getSupportRoles() {
      return this.revenueTeamLine.filter(role =>
          this.getCollectionPercentage(role.amountCollected) < 10
      );
    },

    refreshData() {
      this.revenueTeamLineUp();
    },

    clearFilters() {
      this.search = this.subCountyName;
    },

    menuAccess(){
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Reports Sub County Team");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo",  sessionStorage.getItem("sessionIdNo"));
      execute(data,biller)
          .then((res) => {
            // Success
          })
          .catch((e) => {
            console.error("Menu access error:", e);
          });
    },

    getRight(type){
      return getRight(type)
    },

    gotTo(category,route){
      sessionStorage.setItem("role",category)
      this.$router.push(route);
    },

    formatDate(date) {
      if (!date) return '';
      let d = new Date(date);
      let day = d.getDate();
      let month = d.toLocaleString('en-US', { month: 'short' });
      let year = d.getFullYear();

      let suffix = '';
      if (day % 10 === 1 && day !== 11) {
        suffix = 'st';
      } else if (day % 10 === 2 && day !== 12) {
        suffix = 'nd';
      } else if (day % 10 === 3 && day !== 13) {
        suffix = 'rd';
      } else {
        suffix = 'th';
      }
      return `${day}${suffix} ${month} ${year}`;
    },

    revenueTeamLineUp() {
      this.revenueTeamLine.splice(0)
      this.loading = true

      const data = new FormData();
      data.append("function", "revenueTeamLineUp");
      data.append("page", this.currentPage);
      data.append("rows_per_page", this.pageSize);
      data.append("status", "PAID");
      data.append("dateFrom", this.dateFrom);
      data.append("dateTo", this.dateTo);
      data.append("keyword", this.search)
      data.append("subCountyID", this.subCountyID)

      execute(data, authUrl)
          .then((res) => {
            this.loading = false

            if (res.data.success) {
              this.revenueTeamLine = res.data.data.revenueTeamLine || []

              this.totalCollection = this.revenueTeamLine.reduce((acc, cur) => {
                let total = Number(cur.collections) || 0;
                return acc + total;
              }, 0);

              this.totalInspections = this.revenueTeamLine.reduce((acc, cur) => {
                let total = Number(cur.inspection) || 0;
                return acc + total;
              }, 0);

              this.totalIncoming = this.revenueTeamLine.reduce((acc, cur) => {
                let total = Number(cur.incoming) || 0;
                return acc + total;
              }, 0);

              this.totalOutgoing = this.revenueTeamLine.reduce((acc, cur) => {
                let total = Number(cur.outgoing) || 0;
                return acc + total;
              }, 0);

              this.totalNumber = this.revenueTeamLine.reduce((acc, cur) => {
                let total = Number(cur.totalNumber) || 0;
                return acc + total;
              }, 0);

              this.totalInspectionsValue = this.revenueTeamLine.reduce((acc, cur) => {
                let total = Number(cur.inspectionValue) || 0;
                return acc + total;
              }, 0);

              this.totalAmountCollected = this.revenueTeamLine.reduce((acc, cur) => {
                let total = Number(cur.amountCollected) || 0;
                return acc + total;
              }, 0);

            } else {
              console.log("API returned success: false", res.data.message);
            }
          })
          .catch((e) => {
            this.loading = false;
            console.error("API Error:", e);
            alert("Failed to load team data. Please check your connection and try again.");
          });
    },

    numberFormat(num) {
      const britishNumberFormatter = new Intl.NumberFormat("en-GB");
      return britishNumberFormatter.format(num || 0)
    },

    downloadRevenueTeamLineUp(){
      this.downloading = true;
      this.download = "Please wait.."

      const data = new FormData();
      data.append("function", "downloadRevenueTeamLineUp");
      data.append("page", this.currentPage);
      data.append("rows_per_page", this.pageSize);
      data.append("status", "PAID");
      data.append("dateFrom", this.dateFrom);
      data.append("dateTo", this.dateTo);
      data.append("keyword", this.search)
      data.append("subCountyID", this.subCountyID)

      executeDownload(data,authUrl)
          .then(response => {
            this.download = "Download Report"
            this.downloading = false;

            const link = document.createElement('a');
            link.href = URL.createObjectURL(response.data);
            link.download = `${this.dateFrom}_to_${this.dateTo}_${this.formatSubCountyName(this.subCountyName)}_team_lineup.csv`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          })
          .catch(e => {
            this.download = "Download Report"
            this.downloading = false;
            console.error("Download error:", e);
            alert("Failed to download report. Please try again.");
          });
    },
  }

}
</script>

<style scoped>
.card-h-100 {
  height: 100%;
}

.search-icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #74788d;
}

.table-hover tbody tr:hover {
  background-color: #f8f9fa;
}

.avatar-title {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-size: 12px;
  font-weight: 600;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.bx-spin {
  animation: spin 1s linear infinite;
}

.progress {
  background-color: #f3f3f3;
}

.badge {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
}

.page-link {
  cursor: pointer;
}

.page-item.disabled .page-link {
  cursor: not-allowed;
}
</style>